module.exports = __webpack_public_path__ + "mapPin-secondary.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/mapPin-secondary.png
// module id = 1982
// module chunks = 4